import React, { useEffect, useMemo, useState } from 'react';

import { fetchAllUsers } from '../../api/firebase/fetchAllUsers';
import Sidebar from '../../components/sidebar/sidebar.component';
import { User } from '../../model/zod/user.zod';
import UserFilters from './user-filters/user-filters.component';
import UserListing from './user-listing/user-listing.component';
import './users.styles.scss';

interface UsersProps {
  openSidebar: boolean;
  toggleSidebar: () => void;
}

const Users: React.FC<UsersProps> = ({ openSidebar, toggleSidebar }) => {
  const [users, setUsers] = useState<User[]>([]);
  const [currPage, setCurrPage] = useState('users');

  useEffect(() => {
    fetchAllUsers().then((res) => {
      if (res) {
        setUsers(res);
      }
    });
  }, []);

  // Map function to output each user
  const renderUsers = useMemo(() => {
    return users.map((user) => <UserListing key={user.uid} user={user} />);
  }, [users]);

  const sidebarProps = {
    currPage,
    setCurrPage,
    isOpen: openSidebar,
    toggleSidebar,
  };

  return (
    <section className="usersMainContainer">
      <Sidebar {...sidebarProps} />
      <div className="usersContainer">
        <div className="jobBoardUserLogoContainer">
          <p className="usersTitle"> Interns </p>
          <img
            src="../../../logo_powered_by.png"
            className="mainDashLogo"
            alt="Logo"
          />
        </div>
        <UserFilters />
        <div className="usersWrapper">{users && renderUsers}</div>
      </div>
    </section>
  );
};

export default Users;
